import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import Layout from "../../../components/layout/Layout";
import "../../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../../assets/InnerCSS/css/styles.css";
import "../../../assets/InnerCSS/css/custom.css";
import AdminAllProfilesComponent from "../../../components/admin/company/admin-all-profiles/AdminAllProfilesComponent";
import IdNameModel from "../../../models/common/IdNameModel";
import masterDataService from "../../../services/master-data-service";
import toasterUtils from "../../../utils/toaster-utils";
import modalUtils from "../../../utils/modal-utils";
import { useHistory } from "react-router";
import { RoleEnum } from "../../../models/enums/RoleEnum";
import adminCompanyService from "../../../services/admin/admin-company-service";

const AdminAllProfiles = () => {
    const history = useHistory();
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [companyList, setCompaniesList] = useState<IdNameModel[]>([]);
    const [refreshCompany, setRefreshCompany] = useState<number>(2);
    const [primarySkillList, setPrimarySkillList] = useState<IdNameModel[]>([]);
    const [refreshPrimarySkills, setRefreshPrimarySkills] = useState<number>(2);

    useEffect(() => {
        fillCompanies();
        loadPrimarySkills();
    }, []);

    const fillCompanies = () => {
        setRefreshCompany(2);
        if (loggedInUser && parseInt(loggedInUser.roleId) === parseInt(RoleEnum.Administrator.toString())) {
            modalUtils.showLoader();
            masterDataService.loadCompanies().then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setCompaniesList(res.items);
                setRefreshCompany(refreshCompany * 5);
            }).catch((error) => {
                setRefreshCompany(refreshCompany * 5);
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        } else {
            modalUtils.showLoader();
            adminCompanyService.getCompaniesForIAIRecruiter(loggedInUser ? loggedInUser.profileId : "").then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setCompaniesList(res.items);
                setRefreshCompany(refreshCompany * 5);
            }).catch((error) => {
                setRefreshCompany(refreshCompany * 5);
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const loadPrimarySkills = () => {
        setRefreshPrimarySkills(2);
        modalUtils.showLoader();
        masterDataService.loadPrimarySkills().then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setPrimarySkillList(res.items);
            setRefreshPrimarySkills(refreshPrimarySkills * 5);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> All Profiles
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> All Profiles </h4>
            </div>
            {refreshCompany > 2 && refreshPrimarySkills > 2 &&
                <AdminAllProfilesComponent companiesList={companyList} primarySkillList={primarySkillList} />
            }
        </Layout>
    );
};
export default AdminAllProfiles;